const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();
const signalRBaseUrl = (
  import.meta.env.VITE_SIGNALR_HUB_URL ?? 'https://api.tradexradar.mysris.com'
).trim().replace(/\/+$/, '');
export const API_BASE_URL = (configuredApiBaseUrl || signalRBaseUrl).replace(/\/+$/, '');
export const TRADEXRADAR_HUB_URL = `${signalRBaseUrl}/hubs/tradexradar`;
export const TRADEXRADAR_SNAPSHOT_URL = `${API_BASE_URL}/tradexradar_response.json`;
